import { Chip } from "@mui/material"

const STATUS_CONFIG = {
    "not-started": {
        label: "Not Started",
        sx: {
            backgroundColor: "grey.200",
            color: "grey.800",
            fontWeight: 600,
        },
    },
    "in-progress": {
        label: "In Progress",
        sx: {
            backgroundColor: "info.lighter",
            color: "info.dark",
            fontWeight: 600,
        },
    },
    complete: {
        label: "Mobilisation Complete",
        sx: {
            backgroundColor: "success.lighter",
            color: "success.dark",
            fontWeight: 600,
        },
    },
}

export function MobiliserStatusChip({ status }) {
    const config = STATUS_CONFIG[status] || STATUS_CONFIG["not-started"]

    return (
        <Chip
            label={config.label}
            size="small"
            sx={config.sx}
            role="status"
            title={config.label}
            aria-label={`Mobiliser status: ${config.label}`}
        />
    )
}
